import React from "react";
import { CATEGORY_COLORS, getCategoryIndex } from "../../utils/categoryColors";

// Estrela 5 pontas - path generator
function star5Path(cx, cy, outerR, innerR) {
  var points = [];
  for (var i = 0; i < 5; i++) {
    var outerAngle = (Math.PI / 2) * -1 + (2 * Math.PI * i) / 5;
    points.push(
      (cx + outerR * Math.cos(outerAngle)).toFixed(1) +
        "," +
        (cy + outerR * Math.sin(outerAngle)).toFixed(1)
    );
    var innerAngle = outerAngle + Math.PI / 5;
    points.push(
      (cx + innerR * Math.cos(innerAngle)).toFixed(1) +
        "," +
        (cy + innerR * Math.sin(innerAngle)).toFixed(1)
    );
  }
  return points.join(" ");
}

// Sparkle 4 pontas (losango)
function star4Path(cx, cy, outerR, innerR) {
  var points = [];
  for (var i = 0; i < 4; i++) {
    var outerAngle = (Math.PI / 2) * -1 + (2 * Math.PI * i) / 4;
    points.push(
      (cx + outerR * Math.cos(outerAngle)).toFixed(1) +
        "," +
        (cy + outerR * Math.sin(outerAngle)).toFixed(1)
    );
    var innerAngle = outerAngle + Math.PI / 4;
    points.push(
      (cx + innerR * Math.cos(innerAngle)).toFixed(1) +
        "," +
        (cy + innerR * Math.sin(innerAngle)).toFixed(1)
    );
  }
  return points.join(" ");
}

// Posicoes das sparkles ao redor da estrela central
// Cada nivel adiciona 1 sparkle. Posicoes: superior-direita, inferior-direita, superior-esquerda, inferior-esquerda
var SPARKLE_POSITIONS = [
  { cx: 42, cy: 12, outerR: 7, innerR: 2.5 },  // 1 sparkle (Marfim)
  { cx: 44, cy: 28, outerR: 5.5, innerR: 2 },   // 2 sparkles (Imbuia)
  { cx: 5, cy: 7, outerR: 5, innerR: 1.8 },     // 3 sparkles (Jacaranda)
  { cx: 6, cy: 33, outerR: 4.5, innerR: 1.6 },  // 4 sparkles (Jacaranda Plus)
];

// Componente generico: 1 estrela central outline + N sparkles preenchidas
function EstrelaComSparkles({ color, sparkleCount }) {
  var viewWidth = sparkleCount > 0 ? 52 : 40;
  return (
    <svg width="100%" height="100%" viewBox={"0 0 " + viewWidth + " 40"}>
      {/* Estrela central outline */}
      <polygon
        points={star5Path(sparkleCount > 0 ? 22 : 20, 21, 14, 6)}
        fill="none"
        stroke={color}
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      {/* Sparkles 4 pontas preenchidas */}
      {SPARKLE_POSITIONS.slice(0, sparkleCount).map(function (pos, i) {
        return (
          <polygon
            key={i}
            points={star4Path(pos.cx, pos.cy, pos.outerR, pos.innerR)}
            fill={color}
            stroke="none"
          />
        );
      })}
    </svg>
  );
}

// Componente principal - renderiza a estrela da categoria
export default function EstrelaCategoria({ categoria, size = 32 }) {
  var index = getCategoryIndex(categoria);
  if (index < 0) return null;

  var catNames = ["JATOBÁ", "MARFIM", "IMBUIA", "JACARANDÁ", "JACARANDÁ PLUS"];
  var catName = catNames[index];
  var color = catName === "MARFIM" ? "#C9A06B" : CATEGORY_COLORS[catName];
  var sparkleCount = index; // 0 sparkles para Jatoba, 1 para Marfim, etc.

  return (
    <div style={{ width: size, height: size }}>
      <EstrelaComSparkles color={color} sparkleCount={sparkleCount} />
    </div>
  );
}

// Estrela amarela preenchida para exibir ao lado de "Categoria:" no header
export function EstrelaSideCategoria({ size = 16 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      style={{ marginLeft: 4, flexShrink: 0, marginTop: -3 }}
    >
      <polygon
        points={star5Path(12, 12, 11, 4.5)}
        fill="#ffef00"
        stroke="none"
      />
    </svg>
  );
}
